export const APP_ROUTES = {
    HOME: '',
    BLOG: 'blog',
    LOGIN: 'login',
    BLOGGING: 'blogging',
    BLOG_DETAILS: 'blog/:id',
    PROFILE: 'profile',
} as const;
